const actionTypes = {
  ADD_LOCATIONS: "seneca/locations/ADD_LOCATIONS"
};

export default actionTypes;
